import serialize from "./helpers/serialize";

const axios = require("axios");

class FormQuiz {
  constructor(prop_element = null, prop_currentStepIdx = 0) {
    this.element = prop_element;
    this.steps = [...this.element.querySelectorAll(".js-step")];
    this.formControls = [...this.element.querySelectorAll(".js-form-control")];
    this.btnPrev = this.element.querySelector(".js-btn-prev");
    this.btnNext = this.element.querySelector(".js-btn-next");
    this.progressBar = this.element.querySelector(".js-progress-bar");
    this.currentCounter = this.element.querySelector(".js-progress-current");
    this.currentStepIdx = prop_currentStepIdx;

    this.init();
  }

  init() {
    this.showStep(this.currentStepIdx);

    this.addEvents();
  }

  showStep(prop_stepIdx = 0) {
    const stepIdx = prop_stepIdx;

    this.steps[stepIdx].classList.add("is-active");

    this.btnPrev.classList[stepIdx === 0 ? "remove" : "add"]("is-active");
    this.btnNext.innerText = this.btnNext.dataset[stepIdx === this.steps.length - 1 ? "finalStepText" : "stepText"];

    this.updateProgressBar(stepIdx);
  }

  prevNext(prop_value = 0) {
    const value = prop_value;

    if (value === 1 && !this.validate()) {
      return false;
    }

    document.documentElement.scrollTop = 0;
    this.steps[this.currentStepIdx].classList.remove("is-active");
    this.currentStepIdx += value;

    if (this.currentStepIdx >= this.steps.length) {
      // this.element.submit();
      this.btnNext.type = "submit";
      return false;
    }

    this.currentCounter.innerText = this.currentStepIdx + 1;
    this.showStep(this.currentStepIdx);
  }

  validate() {
    const currentStepRequiredElements = [...this.steps[this.currentStepIdx].querySelectorAll("[required]")];
    let valid = true;

    const uniqNames = [...new Set(currentStepRequiredElements.map(el => el.name))];

    for (let name of uniqNames) {
      let element = this.element.querySelector(`input[name="${name}"]`);
      let elementChecked = this.element.querySelector(`input[name="${name}"]:checked`);

      if (!elementChecked) {
        element.closest(".js-input-group").classList.add("has-error");
        valid = false;
      }
    }

    return valid;
  }

  clearErrors(e) {
    e.target.closest(".js-input-group").classList.remove("has-error");
  }

  updateProgressBar(prop_stepIdx = 0) {
    const percentage = ((prop_stepIdx + 1) / this.steps.length) * 100;
    this.progressBar.style.width = percentage + "%";
  }

  onSubmit(e) {
    e.preventDefault();

    let data = new FormData(this.element);
    let container = document.querySelector(".quiz");

    let params = new FormData();

    params.append("action", "get_results");
    params.append("form", JSON.stringify(serialize(this.element)));
    params.append("page_id", this.element.dataset.id);
    container.innerHTML = '<div class="loader"></div>';
    axios
      .post(WP_DATA.ajax_url, params)
      .then(response => {
        if (response.status === 200) {
          container.classList.add("quiz--results");
          container.innerHTML = response.data.data;
        }
      })
      .catch(error => console.log(error));
  }

  addEvents() {
    for (let formControl of this.formControls) {
      formControl.addEventListener("keyup", this.clearErrors.bind(this));
      formControl.addEventListener("change", this.clearErrors.bind(this));
    }

    this.btnPrev.addEventListener("click", this.prevNext.bind(this, -1));
    this.btnNext.addEventListener("click", this.prevNext.bind(this, 1));
    this.element.addEventListener("submit", this.onSubmit.bind(this));
  }
}

window.addEventListener("DOMContentLoaded", () => {
  window.formQuizObjs = {};

  const formQuizzes = [...document.querySelectorAll(".js-form-quiz")];

  if (formQuizzes.length) {
    for (let formQuiz of formQuizzes) {
      formQuizObjs[formQuiz.id] = new FormQuiz(formQuiz);
    }
  }
});
